<template>
    <section class="content">
        <app-menu v-if="isLoggedIn"></app-menu>
        <div class="container-fluid">
            <div class="block-header">
                <h2>Customer</h2>
            </div>
            <!-- Input -->
            <div class="row clearfix">
                <div col-md-4 offset-md-4>
                    <div class="card">
                        <div class="header">
                            <h2>
                                Create
                                <small>Customer</small>
                            </h2>
                        </div>
                        <div class="body">
                            <form @submit.prevent="submit();" id="customerForm">
                                <label for="collector">Collector</label>
                                <div class="form-group">
                                    <v-select v-model="collector" placeholder="Enter customer name" id="collector"
                                              label="text" :options="[{text: 'Foo', value: 'foo'}]" name="collector" ></v-select>
                                </div>

                                <label for="firstName">First Name</label>
                                <input v-model="first_name" type="text" id="first_name" name="first_name" class="form-control" placeholder="First Name">
                                <!--<label for="middleName">Middle Name</label>-->
                                <!--<div class="row clearfix">-->
                                <!--<div class="col-sm-12">-->
                                <!--<div class="form-group">-->
                                <!--<div class="form-line">-->
                                <!--<input v-model="middle_name" type="text" id="middle_name" name="middle_name" class="form-control" placeholder="Middle Name">-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div>-->
                                <label for="lastName">Last Name</label>
                                <div class="row clearfix">
                                    <div class="col-sm-12">
                                        <input type="text" v-model="last_name" id="last_name" name="last_name" class="form-control" placeholder="Last Name">
                                    </div>
                                </div>
                                <label for="discription">Discription</label>
                                <div class="row clearfix">
                                    <div class="col-sm-12">
                                        <textarea v-model="description" type="text" id="description" name="description" class="form-control no-resize" placeholder="Discription"></textarea>
                                    </div>
                                </div>
                                <label for="dunning_notice">Dunning Notice Activate</label>
                                <div class="body">
                                    <div class="row clearfix">
                                        <div class="col-sm-6">
                                            <select v-model="dunning_notice" id="dunning_notice" name="dunning_notice" class="form-control show-tick">
                                                <option value="high">Yes</option>
                                                <option value="medium">No</option>
                                            </select>
                                        </div>

                                    </div>
                                    <br>

                                    <button type="submit" class="btn general-button btn-success waves-effect pull-left"
                                            v-on:click.prevent="submit">
                                        Submit
                                    </button>
                                    <button class="btn general-button btn-success waves-effect pull-left"
                                            v-on:click.prevent="back">
                                        Back
                                    </button>
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!-- #END# Input -->

        </div>

    </section>

</template>



<script>
//    import {form_customerUrl,configs} from '../config';
    import FrontMenu from '@/components/partials/FrontMenu';
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: "customer",
        mixins: [SessioMixin],
        data() {
            return {
                isLoggedIn: false,
                collector: '',
                first_name: '',
//                middle_name : '',
                last_name: '',
                description: '',
                dunning_notice: [
                    {value: 'yes', text: 'Yes'},
                    {value: 'no', text: 'No'},
                ],
            }
        },

        methods: {
            submit: function () {
                var self = this;
                var fields = $('#customerForm').serializeArray();
                fields.push({name: 'dunning_notice', value: self.dunning_notice.value});
                fields.push({name: 'created_by', value: 1});
                fields.push({name: 'updated_by', value: 2});
                fields.push({name: 'cuid', value: 3});
//                fields.push({name : 'dunning_notice', value : });
                $.ajax({
                    url: 'http://vvg.crm.com/api/v1/createCustomer',
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    success: function (data) {
                        //console.log(data['code']);
                        if (data.status == "success") {
                            //console.log("success");
                            self.$router.push('/listcustomer');
                        }
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            back() {
                this.$router.push({path: '/listcustomer'});
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        }, mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menucustomers").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/customer/CustomerForm.vue